import { CollectParams } from "@lib/titan2-slingo/dist/api/collect/CollectParams";
/*
 * ExtendedCollectParams.ts
 */
export class ExtendedCollectParams extends CollectParams {
    constructor(messageAcknowledged, pick) {
        super(messageAcknowledged);
        this.pick = pick;
    }
    liquify() {
        let data = super.liquify();
        data.putPlainObject("data", { pick: this.pick });
        return data;
    }
}
//# sourceMappingURL=ExtendedCollectParams.js.map